/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Components_File_Tree_Toast_Loading_DescriptionInputs */

const es_components_file_tree_toast_loading_description = /** @type {(inputs: Components_File_Tree_Toast_Loading_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} archivos en cola`)
};

const en_components_file_tree_toast_loading_description = /** @type {(inputs: Components_File_Tree_Toast_Loading_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} files queued`)
};

/**
* | output |
* | --- |
* | "{count} files queued" |
*
* @param {Components_File_Tree_Toast_Loading_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_file_tree_toast_loading_description = /** @type {((inputs: Components_File_Tree_Toast_Loading_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_File_Tree_Toast_Loading_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_file_tree_toast_loading_description(inputs)
	return en_components_file_tree_toast_loading_description(inputs)
});
export { components_file_tree_toast_loading_description as "components.file_tree.toast_loading_description" }